<div class="inline-snackbar" [ngClass]="type">
	<div>
		<mat-icon class="icon">{{ getIcon(type) }}</mat-icon>
		<span class="message">{{ message }}</span>
	</div>
	@if (showCloseButton) {
		<button mat-icon-button (click)="dismiss.emit()">
			<mat-icon>close</mat-icon>
		</button>
	}
</div>
